<template>
  <v-container fluid>
    <v-row>
      <v-col cols="12">
        <v-card>
          <div class="container" v-if="ReportData.length > 0">
            <v-row>
              <v-col>Sell: {{ HeaderInfo.Sell.toLocaleString() }}</v-col>
              <v-col>Buy: {{ HeaderInfo.Buy.toLocaleString() }}</v-col>
              <v-col>Deff: {{ HeaderInfo.Deff.toLocaleString() }}</v-col>
            </v-row>
          </div>
          <v-card-title v-if="ReportData.length > 0">
            <!-- {{ CustomersList }} -->
            Profit Or Loss: {{ ProfitLos.toLocaleString() }}

            <v-spacer></v-spacer>
            <v-text-field
              v-model="search"
              append-icon="mdi-search"
              label="Search"
              single-line
              hide-details
            ></v-text-field>
          </v-card-title>

          <v-data-table
            :loading="searching"
            :headers="headers"
            :items="ReportData"
            :search="search"
          >
            <template v-slot:item.KshAmount="{ item }">
              {{ item.KshAmount.toLocaleString() }}
            </template>
            <template v-slot:item.Rate="{ item }">
              <!-- {{ (item.KshAmount / item.Amount).toLocaleString() }} -->
              <!-- {{
                (
                  Math.round((item.KshAmount / item.Amount) * 10) / 10
                ).toLocaleString()
              }} -->
              {{ item | TranRate(BaseCash) }}
            </template>
            <template v-slot:item.Amount="{ item }">
              {{ item.SourceType | MoneySigns }}
              {{ item.Amount.toLocaleString() }}
            </template>
            <template v-slot:top>
              <v-toolbar flat color="white">
                <v-toolbar-title v-if="fromDate != '' && toDate != ''"
                  >{{ fromDate }} --- {{ toDate }}</v-toolbar-title
                >

                <v-divider class="mx-4" inset vertical></v-divider>
                <div class="flex-grow-1"></div>
                <v-dialog v-model="dialog" max-width="500px" persistent>
                  <template v-slot:activator="{ on }">
                    <v-btn color="primary" dark class="mb-2" v-on="on"
                      >Search by Date
                    </v-btn>
                  </template>
                  <v-card>
                    <v-card-title>
                      <span class="headline">Search transaction by Date</span>
                    </v-card-title>

                    <v-card-text>
                      <v-container>
                        <v-form ref="form" class="mx-5">
                          <v-row>
                            <v-col cols="12">
                              <v-select
                                v-model.trim="TypeAmoun"
                                :items="CurrencyTyps"
                                :rules="[v => !!v || 'Cash Type is required']"
                                label="Cash Type"
                                required
                              ></v-select>
                            </v-col>
                            <v-col cols="12">
                              <v-text-field
                                :loading="searching"
                                :disabled="searching"
                                v-model="fromDate"
                                :rules="[v => !!v || 'From Date is required']"
                                required
                                name="FromDate"
                                label="From Date"
                                type="date"
                              ></v-text-field>
                            </v-col>
                            <v-col cols="12">
                              <v-text-field
                                :loading="searching"
                                :disabled="searching"
                                v-model="toDate"
                                :rules="[v => !!v || 'To Date is required']"
                                required
                                name="ToDate"
                                label="To Date"
                                type="date"
                              ></v-text-field>
                            </v-col>
                          </v-row>
                        </v-form>
                      </v-container>
                    </v-card-text>

                    <v-card-actions>
                      <div class="flex-grow-1"></div>
                      <v-btn
                        color="blue darken-1"
                        :disabled="searching"
                        text
                        @click="close"
                        >Cancel</v-btn
                      >
                      <v-btn
                        color="blue darken-1"
                        :loading="searching"
                        append-icon="mdi-search"
                        text
                        @click="OnSearch"
                        >Search</v-btn
                      >
                    </v-card-actions>
                  </v-card>
                </v-dialog>
              </v-toolbar>
            </template>
          </v-data-table>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
// import { allReq } from "@/axiosfiles/axios-outh";
// import axios from "axios";
import { mapGetters } from "vuex";

export default {
  filters: {
    TranRate(trn, BaseCash) {
      // console.log(trn, val);
      if (BaseCash == "USD")
        return (trn.Amount / trn.KshAmount).toFixed(2).toLocaleString();
      return (trn.KshAmount / trn.Amount).toFixed(2);
    },
  },
  data() {
    return {
      searching: false,
      search: "",
      fromDate: "",
      toDate: "",
      TypeAmoun: "USD",
      headers: [
        {
          text: "Date",
          align: "left",
          value: "date",
        },
        { text: "TranSaction", value: "ExchangeType" },
        { text: "Cash Type", value: "SourceType" },
        { text: "Amount", value: "Amount" },
        { text: "Rate", value: "Rate" },
        { text: "Price", value: "KshAmount" },
        { text: "User", value: "User" },
      ],
      ReportData: [],
      EmptyMessage: "",
      dialog: false,
    };
  },
  computed: {
    ...mapGetters(["GetCashTypes", "LocalCurrencyGetter"]),
    BaseCash() {
      if (this.LocalCurrencyGetter.length)
        return this.LocalCurrencyGetter[0].Cashcode;
      return "KES";
    },
    HeaderInfo() {
      if (this.BaseCash == "USD")
        return {
          Sell: this.Total_Base_Sell,
          Buy: this.Total_Base_Buy,
          Deff: this.Total_Base_Buy - this.Total_Base_Sell,
        };
      return {
        Sell: this.SellTotal,
        Buy: this.BuyTotal,
        Deff: this.SellTotal - this.BuyTotal,
      };
    },
    CurrencyTyps() {
      if (this.GetCashTypes.length > 0)
        return this.GetCashTypes.filter(value => {
          return value.value != this.LocalCurrencyGetter[0].Cashcode;
        });
      else return [];
    },
    SellTotal() {
      return this.ReportData.reduce((total, val) => {
        if (val.ExchangeType === "Sell") return (total += val.Amount);
        return total;
      }, 0);
    },
    BuyTotal() {
      return this.ReportData.reduce((total, val) => {
        if (val.ExchangeType === "Buy") return (total += val.Amount);
        return total;
      }, 0);
    },
    Total_Base_Sell() {
      return this.ReportData.reduce((total, val) => {
        if (val.ExchangeType === "Sell") return (total += val.KshAmount);
        return total;
      }, 0);
    },
    Total_Base_Buy() {
      return this.ReportData.reduce((total, val) => {
        if (val.ExchangeType == "Buy") return (total += val.KshAmount);
        return total;
      }, 0);
    },
    Rates() {
      if (this.BaseCash == "USD") {
        return {
          sellRate: this.SellTotal / this.Total_Base_Sell,
          buyRate: this.BuyTotal / this.Total_Base_Buy,
        };
      }
      return {
        sellRate: this.Total_Base_Sell / this.SellTotal,
        buyRate: this.Total_Base_Buy / this.BuyTotal,
      };
    },

    DeffRate() {
      // console.log(this.Rates);
      if (this.BaseCash == "USD")
        return parseFloat(this.Rates.buyRate - this.Rates.sellRate);
      return parseFloat(this.Rates.sellRate - this.Rates.buyRate);
    },
    Deff() {
      if (this.BaseCash == "USD")
        return this.Total_Base_Buy - this.Total_Base_Sell;
      return this.Total_Base_Sell - this.Total_Base_Buy;
      // return this.SellTotal - this.BuyTotal;
    },
    ProfitLos() {
      // console.log(this.DeffRate);
      if (this.BaseCash == "USD") {
        if (this.Deff > 0) return this.DeffRate * this.Total_Base_Sell;
        else return this.DeffRate * this.Total_Base_Buy;
      } else {
        if (this.Deff > 0) return this.DeffRate * this.BuyTotal;
        else return this.DeffRate * this.SellTotal;
      }
    },
  },

  methods: {
    TranSactions(from, to, Type) {
      if (typeof Type == "object") Type = Type.value;
      return this.$store.dispatch("UPDATE_DATA_Only", {
        url: "/exchange/OtherAmount",
        data: {
          from,
          to,
          SourceType: Type,
        },
      });
    },

    close() {
      this.dialog = false;
    },
    OnSearch() {
      if (this.$refs.form.validate()) {
        this.ReportData = [];

        this.searching = true;
        this.TranSactions(this.fromDate, this.toDate, this.TypeAmoun)
          .then(result => {
            this.ReportData = result.data;
            // console.log(this.ReportData);

            this.searching = false;
          })
          .catch(() => {
            // console.log(error);
            this.searching = false;
          });
      }
    },
  },
  created() {
    this.ReportData = [];

    this.searching = true;
    let date = this.Current();
    // console.log(this.CurrencyTyps);
    // let [money] = Array.from(this.CurrencyTyps);
    // console.log(money);
    this.TranSactions(date.Thismonth, date.date)
      .then(result => {
        // this.ReportData = _.sortBy(result.data, "data");
        this.ReportData = result.data.reverse();
        // console.log(result);

        this.searching = false;
      })
      .catch(() => {
        // console.log(error);
        this.searching = false;
      });
  },
};
</script>
